export interface Memorizable {
	value: string | number
	label?: string
}

export function isMemorizable(x: any): x is Memorizable {
	return !!x?.value
}